import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { GraduationCap, Play } from "lucide-react";

export default function MyTrack() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/my-track").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="text-slate-500">Carregando…</div>;
  return (
    <div className="space-y-8" data-testid="my-track-page">
      <header>
        <div className="eyebrow">Trilha por cargo</div>
        <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight mt-1">Minha trilha de aprendizagem</h1>
        <p className="text-slate-600 mt-2 text-sm">Treinamentos obrigatórios para o seu cargo, status e horas.</p>
      </header>

      <Card>
        <CardContent className="p-6 grid sm:grid-cols-3 gap-4">
          <Stat label="Horas previstas" value={`${data.total_hours}h`} />
          <Stat label="Horas concluídas" value={`${data.completed_hours}h`} />
          <Stat label="Percentual concluído" value={`${data.percent}%`} progress={data.percent} />
        </CardContent>
      </Card>

      {data.courses.length === 0 ? (
        <Card><CardContent className="p-10 text-center text-slate-600">
          <GraduationCap className="w-10 h-10 mx-auto text-slate-400 mb-3" />
          Seu cargo ainda não possui trilha obrigatória definida.
        </CardContent></Card>
      ) : (
        <div className="grid md:grid-cols-2 gap-5">
          {data.courses.map((c) => {
            const enr = c.enrollment;
            const done = enr?.status === "completed";
            return (
              <Card key={c.id} className="border-[var(--unigr-border)]">
                <CardContent className="p-5">
                  <div className="flex items-start justify-between">
                    <div className="font-display font-bold text-lg">{c.title}</div>
                    {done ? <Badge className="bg-emerald-100 text-emerald-700 border-0">Concluído</Badge> :
                      enr ? <Badge variant="secondary">Em andamento</Badge> : <Badge variant="outline">Pendente</Badge>}
                  </div>
                  <p className="text-sm text-slate-600 mt-1">{c.description}</p>
                  <Progress value={enr?.progress || 0} className="mt-3" />
                  <div className="flex justify-between mt-2 text-xs text-slate-500">
                    <span>{enr?.progress || 0}%</span><span>{c.duration_hours}h</span>
                  </div>
                  <Link to={`/courses/${c.id}`}>
                    <Button className="btn-navy w-full mt-4" data-testid={`track-open-${c.id}`}><Play className="w-4 h-4 mr-2" />Acessar</Button>
                  </Link>
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}

function Stat({ label, value, progress }) {
  return (
    <div>
      <div className="text-xs text-slate-500 uppercase tracking-wide">{label}</div>
      <div className="font-display font-extrabold text-2xl mt-1">{value}</div>
      {typeof progress === "number" && <Progress value={progress} className="mt-2" />}
    </div>
  );
}
